import StudentResources from "./components/studentResources";
import StudentTransactions from "./components/studentTransactions";
import StudentScholarship from "./components/studentScholarship";
import StudentFinacialAssistance from "./components/studentFinacialAssistance";
import { IStudentAccounts } from "../../../models/student/studentAccountsDetails";
import { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import StudentAccountDetail from "./components/studentAccount";
import { getPageBlockData } from "../../../common-functions/commonFunctions";
import { pageBlockId } from "../../../constants/pageBlocks";
import { getSnapShots } from "../../../action/masters/snapShotActionCreator";
import { setSnapShots } from "../../../store/slices/master/snapShotSlice";

const StudentAccounts = (props: IStudentAccounts) => {
  const { getSnapShots, snapShots } = props;

  const dispatch = useDispatch();

  useEffect(() => {
    getSnapShots();
  }, []);

  useEffect(() => {
    return () => {
      dispatch(setSnapShots([]));
    };
  }, []);

  return (
    <div className="row studacct-mobile">
      <div className="col-lg-12 mb-3">
        <div className="card-wrap h-auto">
          <StudentAccountDetail />
        </div>
      </div>
       <div className="col-lg-12 mb-3 mobile-stud-resouces d-none">
            <div className="card-wrap">{<StudentTransactions />}</div>
          </div>
      <div className="col-lg-6">
        <StudentResources />
      </div>
      <div className="col-lg-6">
        <div className="row">
          <div className="col-lg-12 desktop-stud-resouces">
            <div className="card-wrap">{<StudentTransactions />}</div>
          </div>
          <div className="col-lg-6 mt-3">
            <StudentScholarship />
          </div>
          <div className="col-lg-6 mt-3">
            <StudentFinacialAssistance />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  getSnapShots: () => getSnapShots(),
};

function mapStateToProps(state: any) {
  return {
    snapShots: state.snapShot.snapShots,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(StudentAccounts);
